import { APPC } from "../config";

type useAppUtilType = {
    statusVariant: (status: string) => string;
};

export function useAppUtil(): useAppUtilType {
    const statusVariant = (status: string) => {
        switch (status) {
            case APPC.BE.DonationTransaction.TRANSACTION_STATUS_SUCCESS:
                return "green";
            case APPC.BE.DonationTransaction.TRANSACTION_STATUS_FAILED:
                return "red";
            default:
                return "solid";
        }
    };
    return {
        statusVariant,
    };
}
